<template>
  <vue-final-modal
    v-slot="{ params, close }"
    v-bind="$attrs"
    classes="w-screen h-screen overflow-auto flex bg-skin-b-back"
    content-class="container mx-auto wrapper max-w-5xl"
  >

  <div class="w-full h-24 flex bg-skin-b-list-back divide-x md:border-x border-b border-skin-b-list-bord shadow lg:rounded-b-lg">
      <div class="inline-flex">
        <button type="button"  @click="close"
        class="inline-flex items-center px-4 py-0 text-sm font-medium rounded-bl-lg
                                    text-skin-b-list-base bg-skin-b-list-back 
                                    hover:text-skin-b-base hover:bg-skin-b-list-head  
                                    focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base 
                                    transition duration-300 ease-in-out">
        <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 96 960 960" width="20">
          <path d="m291 816-51-51 189-189-189-189 51-51 189 189 189-189 51 51-189 189 189 189-51 51-189-189-189 189Z"/>
        </svg>
        </button>
      </div>
      <div class="inline-flex grow pl-6">
        <div class="my-auto pr-4 hidden sm:inline-block">
          <slot name="icon"></slot>
        </div> 
        <div class="my-auto">
          <h1 class="font-bold text-skin-b-list-base text-2xl truncate"><slot name="title"></slot></h1>
        </div>
      </div>
    </div>

    <div class="mx-4 my-6 p-4 max-w-5xl bg-skin-b-list-back border border-skin-b-list-bord shadow rounded-lg">
      <slot :params="params"></slot>
    </div>


    <div class="mx-4 pb-8 max-w-5xl flex items-center justify-between">
      <button class="vfm-btn px-4 py-2 h-12
          rounded-lg border-2 border-transparent
          font-semibold text-lg text-skin-b-invt 
          bg-skin-active128
          disabled:opacity-50 disabled:hover:bg-skin-active128 
          hover:bg-skin-active96
          focus:bg-skin-active128 focus:outline-none focus:ring-0 
          active:bg-skin-active128 
          transition duration-300 ease-in-out" 
      @click="$emit('confirm', close)">{{ $t('common.close') }}</button>
    </div>
  </vue-final-modal>
</template>

<script>
export default {
  name: 'VCardPairModal',
  inheritAttrs: false,
  emits: ['cancel', 'confirm']
}
</script>
